import { useQuery } from '@tanstack/react-query';
import { useUniversalNavContext } from '../../universal-nav/hooks/useUniversalNavContext';
const groupPlansByPlanType = (planData) => {
    const planTypes = [
        'Free',
        'Starter',
        'Professional',
        'Team',
        'Company',
        'Enterprise',
    ];
    const planGroups = [];
    for (const planType of planTypes) {
        const plansInGroup = planData
            .filter((plan) => plan.plan_type === planType)
            .sort((a, b) => a.actions - b.actions)
            .map((plan) => ({
            id: plan.id,
            name: plan.name,
            interval: plan.interval,
            amount: plan.amount,
            type: plan.plan_type,
            isInPlanGroup: !plan.off_plan_group || false,
            actions: plan.actions,
            includedTasksPerMonth: plan.included_tasks_per_month,
            limits: {
                isSelfServe: plan.limits.is_self_serve,
            },
            meteredPricingTiers: plan.metered_pricing_tiers.map(([numTasks, pricePerTask]) => ({
                numTasks,
                pricePerTask,
            })),
        }));
        planGroups.push({
            planType,
            plans: plansInGroup,
        });
    }
    return planGroups;
};
export const useQueryPlans = (currentAccountId) => {
    const { apiHostname } = useUniversalNavContext();
    const result = useQuery({
        queryKey: ['accountPlans', currentAccountId],
        queryFn: async () => {
            const endpoint = `${apiHostname}/api/v3/accounts/${currentAccountId}/plans`;
            const response = await fetch(endpoint, {
                credentials: process.env.NODE_ENV !== 'test' ? 'include' : 'same-origin',
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const plansJson = await response.json();
            return plansJson.objects;
        },
        enabled: !!currentAccountId,
        select: groupPlansByPlanType,
    });
    return Object.assign(Object.assign({}, result), { isLoading: result.isInitialLoading });
};
//# sourceMappingURL=useQueryPlans.js.map
// @zapier/universal-layout@11.0.80 (863ea7570)
